import { ReportDefinition, ReportTypes } from "./types";

export const giftcardsDefinition: ReportDefinition = {
    translationKey: "report.giftcard.name",
    reportType: ReportTypes.GIFTCARDS,
    primaryTable: "rm_account",
    joins: {
        account_transaction: {
            sql: "JOIN rm_account_transaction ON rm_account_transaction.account_id = rm_account.id",
        },
        user: {
            sql: 'LEFT JOIN "user" ON "user".id = rm_account_transaction.user_id',
            dependOn: ["account_transaction"],
        },
    },
    fields: {
        account_name: {
            translationKey: "report.columns.account_name",
            type: "SIMPLE",
            field: { table: "rm_account", column: "name" },
            selectedByDefault: true,
        },
        report_date: {
            translationKey: "report.columns.report_date",
            type: "CUSTOM",
            content:
                "TO_CHAR(rm_account_transaction.transaction_at::TIMESTAMPTZ AT TIME ZONE {{time_zone}}, 'YYYY-MM-DD HH24:MI:SS')",
            selectedByDefault: true,
            dependOnJoin: ["account_transaction"],
            formatAs: "DATETIME",
        },
        user_name: {
            translationKey: "report.columns.username",
            type: "SIMPLE",
            field: { table: "user", column: "username" },
            selectedByDefault: true,
            dependOnJoin: ["user"],
        },
        amount: {
            translationKey: "report.columns.amount",
            type: "SUM_AMOUNT",
            field: {
                table: "rm_account_transaction",
                column: "amount",
            },
            selectedByDefault: true,
            dependOnJoin: ["account_transaction"],
            formatAs: "AMOUNT",
        },
    },
    filters: {
        merchant_id: {
            field: { table: "rm_account", column: "merchant_id" },
            translationKey: "report.columns.merchant_id",
            type: "EQUALS",
            internalUse: true,
        },
        report_date: {
            field: {
                table: "rm_account_transaction",
                column: "transaction_at",
            },
            translationKey: "report.columns.report_date",
            type: "BETWEEN",
            dependOnJoin: ["account_transaction"],
        },
        type: {
            translationKey: "report.columns.type",
            type: "CUSTOM",
            content: "rm_account.type = 'GIFT_CARD'",
            internalUse: true,
        },
    },
    grouping: {
        year: {
            translationKey: "report.columns.year",
            type: "YEAR",
            field: {
                table: "rm_account_transaction",
                column: "transaction_at",
            },
            dependOnJoin: ["account_transaction"],
        },
        month: {
            translationKey: "report.columns.month",
            type: "MONTH",
            field: {
                table: "rm_account_transaction",
                column: "transaction_at",
            },
            dependOnJoin: ["account_transaction"],
        },
        day: {
            translationKey: "report.columns.day",
            type: "DAY",
            field: {
                table: "rm_account_transaction",
                column: "transaction_at",
            },
            dependOnJoin: ["account_transaction"],
        },
    },
    ordering: {
        report_date: {
            translationKey: "report.columns.report_date",
            type: "CUSTOM",
            content: "report_date",
        },
        account_name: {
            translationKey: "report.columns.account_name",
            type: "FIELD",
            field: "rm_account.name",
        },
        amount: {
            translationKey: "report.columns.amount",
            type: "FIELD",
            field: "amount",
        },
    },
};
